export default function({ state, commit, dispatch }, update) {
    return dispatch('patch', {
        url: '/provider/' + ( state.id ? state.id : update.provider ) + '/patient/' + update.patient + '/recommendation/' + update.recommendation,
        data: update.feedback
    }, {
        root: true
    })
    .then((response) => {
        console.log('updatePatientRecommendationFeedback response', response)
        commit('updatePatientRecommendationFeedback', {
            id: update.patient,
            feedback: response.feedback || {},
            meta: response.meta || []
        })
    })
    .catch((error) => {
        console.error('Error updating patient recommendation feedback:', error)
        throw error
    })
}
